import { render, staticRenderFns } from "./CustomersRecord.vue?vue&type=template&id=ae774368&scoped=true"
import script from "./CustomersRecord.vue?vue&type=script&lang=js"
export * from "./CustomersRecord.vue?vue&type=script&lang=js"
import style0 from "./CustomersRecord.vue?vue&type=style&index=0&id=ae774368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae774368",
  null
  
)

export default component.exports